export const knowServiceComerciales = [
    {
        "header": "CONOCE NUESTROS",
        "title": "SERVICIOS PROFESIONALES",
        "subtitle": "PARA EMPRESAS",
        "description": "Contamos con Servicios Comerciales de mantenimiento y Restauración en zonas de difícil acceso las cuales requieren de experiencia para un trabajo bien ejecutado con seguridad de nivel industrial y profesionalismo.",
        "button": "PROYECTOS",
        "buttonLink": "/proyectos", 
        "specializedHeader": "CONTAMOS",
        "specializedTitle": "CON PERSONAL",
        "specializedSubtitle": "CERTIFICADO",
        "image": "/assets/imgs/services/comerciales/fondo-know.jpg",
        "backgroundColor": "#FFCD00"
    }
];

export const knowServiceComercialesEn = [
    {
      header: "DISCOVER OUR",
      title: "PROFESSIONAL SERVICES",
      subtitle: "FOR BUSINESSES",
      description:
        "We offer commercial maintenance and restoration services in hard-to-reach areas that require expertise for a well-executed job with industrial-level safety and professionalism.",
      button: "PROJECTS",
      buttonLink: "/projects",
      specializedHeader: "WE HAVE",
      specializedTitle: "CERTIFIED",
      specializedSubtitle: "STAFF",
      image: "/assets/imgs/services/comerciales/fondo-know.jpg",
      backgroundColor: "#FFCD00"
    }
  ];  